// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rentalRegistrationInitizlization_wrapper__3h0gW"};